import React from 'react';
export const Ticker = () => {
  // `sale` items belong to the limited-time Halloween promo layer and render
  // in orange so the offer reads distinctly from the evergreen brand claims.
  const items: {
    label: string;
    sale?: boolean;
  }[] = [{
    label: 'HALLOWEEN SALE — 60% OFF',
    sale: true
  }, {
    label: 'BUILT BY OPERATORS'
  }, {
    label: 'FREE SHIPPING — USA',
    sale: true
  }, {
    label: 'NOT SOLD IN STORES'
  }, {
    label: 'LIMITED HALLOWEEN STOCK',
    sale: true
  }, {
    label: 'FIELD TESTED — FIELD PROVEN'
  }, {
    label: '12,400+ UNITS DEPLOYED'
  }, {
    label: 'THE COSTUME THAT OUTLASTS THE NIGHT',
    sale: true
  }, {
    label: 'LIFETIME WARRANTY'
  }, {
    label: "THE MASK THEY COULDN'T FIND — SO THEY BUILT IT"
  }, {
    label: 'BLACKOUT UNIT™'
  }];
  // Duplicate for seamless loop
  const tickerItems = [...items, ...items];
  return <div className="bg-dark-1 border-y border-acid-green/10 py-3 overflow-hidden flex whitespace-nowrap" data-id="element-1455" data-mp="2dz5aas2x8dgh">
      <div className="animate-marquee flex items-center" data-id="element-1456" data-mp="2iwey63anwh27">
        {tickerItems.map((item, index) => <div key={index} className="flex items-center mx-8" data-id="element-1457" data-mp="2nphswer6dwjz" data-mpi={index}>
            <span className={`mr-4 text-sm inline-block w-2 h-2 rotate-45 ${item.sale ? 'bg-halloween-orange' : 'bg-acid-green'}`} data-id="element-1458" data-mp="2sn03e9kucju3"></span>
            <span className={`font-barlow font-bold text-sm tracking-[3px] uppercase ${item.sale ? 'text-halloween-orange' : 'text-text-body'}`} data-id="element-1459" data-mp="1v1lzbiwwkkrf">
              {item.label}
            </span>
          </div>)}
      </div>
    </div>;
};